import { handleError, handleSuccess, triggerGet, triggerPost, triggerPostFormData, triggerPut } from './utils';

const getAccountAndAgreementsApiRequest = async () => {
  const checkIfSuccess = obj => obj.success || obj.status === 404;
  const [account, accountAgreements] = await Promise.all([getAccountApiRequest(), getAccountApiAgreements()]);
  if (checkIfSuccess(account) && checkIfSuccess(accountAgreements)) {
    const newResponse = { success: true, data: { account: account.data, agreements: accountAgreements.data } };
    return handleSuccess(newResponse);
  }
  return { success: false };
};

const getAccountApiRequest = async () => {
  const apiResponse = await triggerGet('/user/account');
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData, true);
  }
  return handleError(responseData);
};

const getAccountApiAgreements = async () => {
  const apiResponse = await triggerGet('/user/agreements/');
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

const saveAccountApiRequest = async data => {
  const apiResponse = await triggerPut('/user/account', data);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

const updateAccountImageRequest = async data => {
  const apiResponse = await triggerPostFormData('/user/account/image', data);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

const saveAgreementsApiRequest = async data => {
  const apiResponse = await triggerPost('/user/agreements/', data);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

const changeUserPasswordApiRequest = async data => {
  const apiResponse = await triggerPut('/user/account/password/', data);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

const changeProfilePictureApiRequest = async (image, naturalWidth, naturalHeight) => {
  const apiPayload = {
    users_image: image,
    images_x: 0,
    images_y: 0,
    images_width: naturalWidth,
    images_height: naturalHeight,
  };

  const apiResponse = await triggerPut('/user/account/image/', apiPayload);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

export {
  changeProfilePictureApiRequest,
  changeUserPasswordApiRequest,
  getAccountAndAgreementsApiRequest,
  getAccountApiAgreements,
  getAccountApiRequest,
  saveAccountApiRequest,
  saveAgreementsApiRequest,
  updateAccountImageRequest,
};
